declare global {
  interface Window {
    dht?: (...args: any[]) => void;
  }
}

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const dailyhuntPixelEnabled = runtimeConfig.public.dailyhuntPixelEnabled === true;

  if (!import.meta.client || !dailyhuntPixelEnabled) return;

  (function (w: Window, d: Document, tagName: string, src: string) {
    if (w.dht) return;
    let n: any = function (...args: any[]) {
      n.track ? n.track.apply(n, args) : n.queue.push(args);
    };
    n.queue = [];
    w.dht = n;

    const script = d.createElement(tagName) as HTMLScriptElement;
    script.async = true;
    script.src = src;
    script.id = 'dht';

    const firstScript = d.getElementsByTagName(tagName)[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
  })(window, document, 'script', 'https://assets-money.dailyhunt.in/dht.min.js');

  window.dht?.('init', '');
});
